import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/oB9PfgD";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_画面下部固定";

export default function FixedCTA() {
  return (
    <div className="fixed bottom-0 left-0 w-full z-50 bg-white border-t border-gray-200 py-3 px-4 shadow-lg">
      <div className="max-w-lg mx-auto flex flex-col items-center gap-1">
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
          className="whitespace-nowrap w-full flex items-center justify-center gap-3 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-base py-3 px-8 rounded-full transition-all cursor-pointer shadow-[0_6px_20px_rgba(0,185,0,0.5)] hover:shadow-[0_10px_30px_rgba(0,185,0,0.65)] hover:scale-[1.02]"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-line-fill text-xl"></i>
          </span>
          公式LINEを友だち追加する
        </a>
        <p className="text-xs text-gray-500">まずはLINEで仕組みを確認</p>
      </div>
    </div>
  );
}
